import { Link, useLocation } from "react-router-dom";
import { posts } from "../data/posts";

export default function PostNavigation() {
  const { pathname } = useLocation();

  if (!pathname.startsWith("/blog/") || pathname === "/blog/") {
    return null;
  }

  const normalizedPath = pathname.endsWith("/") ? pathname : pathname + "/";
  const currentIndex = posts.findIndex(
    (p) => p.path === pathname || p.path === normalizedPath
  );

  if (currentIndex === -1) return null;

  const newerPost = currentIndex > 0 ? posts[currentIndex - 1] : null;
  const olderPost = currentIndex < posts.length - 1 ? posts[currentIndex + 1] : null;

  if (!newerPost && !olderPost) return null;

  return (
    <nav className="post-nav" aria-label="Article navigation">
      <div className="post-nav-col post-nav-prev">
        {newerPost ? (
          <Link to={newerPost.path} className="post-nav-link">
            <span className="post-nav-dir">&larr; Newer Article</span>
            <span className="post-nav-title">{newerPost.title}</span>
            {newerPost.readTime && (
              <span className="post-nav-meta">{newerPost.readTime}</span>
            )}
          </Link>
        ) : (
          <div className="post-nav-placeholder" />
        )}
      </div>

      <div className="post-nav-col post-nav-next">
        {olderPost ? (
          <Link to={olderPost.path} className="post-nav-link">
            <span className="post-nav-dir">Older Article &rarr;</span>
            <span className="post-nav-title">{olderPost.title}</span>
            {olderPost.readTime && (
              <span className="post-nav-meta">{olderPost.readTime}</span>
            )}
          </Link>
        ) : (
          <div className="post-nav-placeholder" />
        )}
      </div>
    </nav>
  );
}
